import { getModuleUrl, i18n } from "@dehub/theme";
import { store, persistor } from "../store";
import { message } from "./message";
import { authChange } from "../store/Auth";
import HttpHandler from "./http-handler";
import { HttpRequest as BaseHttpRequest } from "./http-request";

const regNumber = /^[0-9]{7}$/;
// Individual (хувь хүн) register number: 2 Cyrillic letters + 8 digits, e.g. "УБ12345678"
const citizenRegNumber = /^[А-Яа-яҮүӨөЁё]{2}[0-9]{8}$/;
// A valid taxpayer number is EITHER a 7-digit company ТТД OR an individual register.
// Use this for generic tax-number fields where the partner may be a citizen or a company.
const taxNumber = /^(?:[0-9]{7}|[А-Яа-яҮүӨөЁё]{2}[0-9]{8})$/;
const numberRegex = /[0-9]/gm;

let sessionExpiredHandled = false;

export class HttpRequest extends BaseHttpRequest {
  store = store;
  errorHandler = (statusCode: number, error: HttpHandler): void => {
    if (statusCode === 401 && !sessionExpiredHandled) {
      sessionExpiredHandled = true;
      store.dispatch(authChange());
      message.error(i18n.t("common:session.expired", { defaultValue: "Таны нэвтэрсэн хугацаа дууссан байна. Дахин нэвтэрнэ үү." }));

      const h = window.location.hostname.split(".");
      const loginUrl = `${h.length >= 3 && h[0] === "b2b" ? window.location.origin : getModuleUrl("")}/login?logout=1`;

      persistor.purge().finally(() => {
        setTimeout(() => {
          window.location.href = loginUrl;
        }, 1500);
      });
    }

    throw error;
  };
}

export { citizenRegNumber, numberRegex, regNumber, taxNumber };

// `currencyFormat` / `tugrug` live in a leaf module so that the members this
// barrel re-exports below can import them without importing the barrel itself
// — see the header of ./currency.
export { currencyFormat, tugrug } from "./currency";

export {
  calcTermDiscount,
  findTermDiscount,
  termDiscountLabel,
  termDiscountSuffix,
} from "./payment-term-discount";
export type { ITermDiscount, ITermWithDiscount } from "./payment-term-discount";

export {
  DEFAULT_VAT_PERCENT,
  lineDiscountAmount,
  lineGrossAmount,
  lineNetAmount,
  lineTaxAmount,
  lineVatAmount,
  STANDARD_RATED,
  unitTaxAmount,
  unitVatAmount,
} from "./order-amounts";
export type { IOrderLine } from "./order-amounts";
